import React from "react";
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { PiGlobeHemisphereWestDuotone } from "react-icons/pi";
import { IoIosCall } from "react-icons/io";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import ContactUsForm from "../common/ContactUsForm";
import Footer from "../common/Footer";
import ReviewSlider from "../common/ReviewSlideer";
import AppPromotionBanner from "../components/core/HomePage/AppPromotionBanner";
import "./Contact.css";

const contactItems = [
  {
    icon: <HiChatBubbleLeftRight />,
    title: "Chat with us",
    description: "Our friendly team is here to help.",
    detail: "admin@cntacademy.com",
  },
  {
    icon: <PiGlobeHemisphereWestDuotone />,
    title: "Visit our office",
    description: "Meet the team at our Howrah office.",
    detail: "Agnostic Edufin Private Limited, 212 Girish Ghosh Road, Belur, Howrah, West Bengal 711202",
  },
  {
    icon: <IoIosCall />,
    title: "Call us",
    description: "Monday–Friday, 8:00 AM–5:00 PM",
    detail: "+91 7384708366",
  },
];

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61565847206124",
    icon: <FaFacebookF />,
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/cntacademyofficial/",
    icon: <FaInstagram />,
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@cntacademyofficial",
    icon: <FaYoutube />,
  },
  {
    name: "X",
    href: "https://x.com/cntacademy",
    icon: <FaXTwitter />,
  },
];

const Contact = () => (
  <main className="market-contact">
    <section className="market-page-hero">
      <div className="market-page-wrap">
        <span>CONTACT CNT ACADEMY</span>
        <h1>Let’s find the right learning path for you.</h1>
        <p>
          Have a course question, need account support, or want help deciding
          where to begin? Our team would be happy to assist.
        </p>
      </div>
    </section>

    <section className="market-contact-main">
      <div className="market-page-wrap market-contact-grid">
        <div className="market-contact-aside">
          <div className="market-contact-list">
            {contactItems.map(item => (
              <article key={item.title}>
                <i>{item.icon}</i>
                <div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                  <b>{item.detail}</b>
                </div>
              </article>
            ))}
          </div>
          <div className="market-map">
            <iframe
              title="CNT Academy office location"
              src="https://www.google.com/maps?q=212,+Girish+Ghosh+Road,+Belur,+Howrah,+West+Bengal+711202,+India&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>

        <div className="market-contact-form">
          <span>WRITE TO US</span>
          <h2>How can we help?</h2>
          <p>Share a few details and our team will get back to you shortly.</p>
          <ContactUsForm />
        </div>
      </div>
      <div className="market-page-wrap market-follow">
        <div>
          <span>STAY CONNECTED</span>
          <h3>Follow us on social media</h3>
          <p>Market education, academy updates, and learning resources.</p>
        </div>
        <div className="market-follow-links">
          {socialLinks.map((social) => (
            <a
              key={social.name}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Follow CNT Academy on ${social.name}`}
              title={social.name}
            >
              {social.icon}
              <span>{social.name}</span>
            </a>
          ))}
        </div>
      </div>
    </section>

    <section className="market-social-proof">
      <div className="market-page-wrap">
        <span>LEARNER STORIES</span>
        <h2>What our students say</h2>
        <ReviewSlider />
      </div>
    </section>
    <AppPromotionBanner />
    <Footer />
  </main>
);

export default Contact;
